import { render, staticRenderFns } from "./loses.vue?vue&type=template&id=66acb874&"
import script from "./loses.vue?vue&type=script&lang=js&"
export * from "./loses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports